module.exports = __webpack_public_path__ + "img/img24.5d2986f5.jpg";